import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { AvField, AvForm } from "availity-reactstrap-validation";
import List from "./List";

import * as _service from "../../service/parts.service";

const SpareParts = () => {
  const formRef = useRef();

  const [data, setData] = useState([]);
  const [masterObject, setMasterObject] = useState({});

  useEffect(() => {
    handleTableData();
  }, []);

  const handleTableData = async () => {
    try {
      const response = await _service.list();
      const { data } = response;
      setData(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      const method = masterObject.id ? _service.update : _service.create;
      const response = await method(masterObject);

      toast.success(response.message);
      reset();
    } catch (error) {
      console.error(error);
      toast.error(error?.message);
    }
  };

  const handleUpdate = (item) => {
    setMasterObject({ ...item, id: item._id });
  };

  const handleValueChange = ({ value, name }) => {
    setMasterObject((prev) => ({ ...prev, [name]: value }));
  };

  const reset = () => {
    formRef.current?.reset();
    setMasterObject({});
    handleTableData();
  };

  return (
    <>
      <h5 className="page-title">Spare Parts</h5>
      <div className="card">
        <div className="card-body">
          <AvForm ref={formRef} onValidSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-3 mb-3">
                <label>Spare Part</label>
                <AvField
                  type="name"
                  name="name"
                  validate={{ required: { value: true } }}
                  placeholder="Spare Part"
                  errorMessage="Enter Spare Part Name"
                  value={masterObject?.name || ""}
                  onChange={(e) => handleValueChange(e.target)}
                />
              </div>
              <div className="col-md-2 mb-3">
                <label>Amount</label>
                <AvField
                  type="number"
                  name="amount"
                  placeholder="Amount"
                  validate={{
                    required: { value: true },
                    min: { value: 1, errorMessage: "Amount must be greater than zero" },
                  }}
                  errorMessage="Enter Amount"
                  value={masterObject?.amount || ""}
                  onChange={(e) => handleValueChange(e.target)}
                />
              </div>

              <div className="col-md-3 mb-3 d-flex gap-2 form-button">
                <button className="btn btn-submit">{masterObject.id ? "Update" : "Submit"}</button>
                <button className="btn btn-reset" type="reset" onClick={reset}>
                  Reset
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
      <List data={data} onDelete={reset} onEdit={handleUpdate} />
    </>
  );
};

export default SpareParts;
